<ng-container *ngIf="viewModel$ | async as viewModel">
	<div class="group-details-page">
		<div class="group-details-page__content" *ngIf="selectedTabId$ | async as selectedTabId">
			<div class="group-details-page__header">
				<div class="group-details-page__title-row">
					<div class="group-details-page__title">Group details</div>
					<div class="group-details-section-nav" role="tablist" aria-label="Group detail sections">
						<button
							type="button"
							class="group-details-section-nav__item"
							*ngFor="let tab of tabInfo"
							[class.group-details-section-nav__item--active]="tab.id === selectedTabId"
							(click)="onTabClick(tab)">
							<i [class]="tab.icon"></i>
							<span>{{ tab.text }}</span>
						</button>
					</div>
				</div>
				<div class="group-details-page__actions">
					<dx-button text="Back" type="normal" icon="back" (onClick)="back()"></dx-button>
					<dx-button text="Save" type="success" icon="save" [disabled]="(saving$ | async) || !hasPendingChanges()" (onClick)="saveGroup()"></dx-button>
				</div>
			</div>

			<div *ngIf="selectedTabId === 'information'" class="group-details-form">
				<div class="group-details-form__field">
					<label>Name</label>
					<dx-text-box [(value)]="formModel.name"></dx-text-box>
				</div>
				<div class="group-details-form__field">
					<label>Description</label>
					<dx-text-box [(value)]="formModel.description"></dx-text-box>
				</div>
				<div class="group-details-form__checkbox">
					<dx-check-box [(value)]="formModel.isDefaultGroup" text="Is default" [disabled]="!canChangeDefaultGroupSetting()"></dx-check-box>
				</div>
			</div>

			<div *ngIf="selectedTabId === 'users'">
				<dx-data-grid [dataSource]="viewModel.users" [showBorders]="true" height="calc(100vh - 380px)">
					<dxo-sorting mode="multiple"></dxo-sorting>
					<dxo-filter-row [visible]="true"></dxo-filter-row>
					<dxo-search-panel [visible]="true"></dxo-search-panel>
					<dxo-pager [showPageSizeSelector]="true"></dxo-pager>
					<dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
					<dxi-column dataField="userDisplayName" caption="User"></dxi-column>
					<dxi-column dataField="userId" caption="User ID" [width]="120"></dxi-column>
				</dx-data-grid>
			</div>

			<div *ngIf="selectedTabId === 'permissions'" class="group-details-permissions">
				<div class="group-details-permissions__toolbar">
					<dx-text-box [value]="searchValue$ | async" (onValueChanged)="searchValue$.next($event.value ?? '')" placeholder="Search permissions..."></dx-text-box>
					<div class="group-details-permissions__notice" *ngIf="!canManageGroupPermissions">
						Only Super ApplicationLink Administrators can assign or revoke group permissions.
					</div>
				</div>

				<div *ngIf="{ searchValue: searchValue$ | async } as filterState" class="permission-transfer">
					<div class="permission-transfer__panel" *ngIf="availablePermissions(filteredPermissions(permissionRows, filterState.searchValue ?? '')) as availablePermissions">
						<div class="permission-transfer__title-row">
							<div class="permission-transfer__title">Available permissions</div>
							<div class="permission-transfer__count">{{ availablePermissions.length }}</div>
						</div>

						<dx-data-grid
							class="permission-transfer__grid"
							[dataSource]="availablePermissions"
							keyExpr="permissionKey"
							[showBorders]="true"
							[hoverStateEnabled]="true"
							[rowAlternationEnabled]="true"
							[width]="'100%'"
							[columnAutoWidth]="false"
							[wordWrapEnabled]="true"
							[selectedRowKeys]="availableSelectedRowKeys"
							[selection]="{ mode: canManageGroupPermissions ? 'multiple' : 'none' }"
							(onSelectionChanged)="onAvailableSelectionChanged($event)">
							<dxo-selection [mode]="canManageGroupPermissions ? 'multiple' : 'none'" [showCheckBoxesMode]="canManageGroupPermissions ? 'always' : 'none'" selectAllMode="page"></dxo-selection>
							<dxo-sorting mode="multiple"></dxo-sorting>
							<dxo-filter-row [visible]="false"></dxo-filter-row>
							<dxo-search-panel [visible]="false"></dxo-search-panel>
							<dxo-paging [enabled]="true" [pageSize]="12"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
							<dxi-column dataField="category" caption="Group" [width]="160"></dxi-column>
							<dxi-column dataField="displayPermissionName" caption="Permission" [minWidth]="180"></dxi-column>
							<dxi-column dataField="permissionCode" caption="Code" [width]="250"></dxi-column>
							<dxi-column dataField="permissionKey" caption="ID" [visible]="false"></dxi-column>
							<dxi-column dataField="displayPermissionDescription" caption="Permission description" [minWidth]="180"></dxi-column>
						</dx-data-grid>
					</div>

					<div class="permission-transfer__actions">
						<dx-button
							icon="chevronnext"
							text=">"
							type="default"
							stylingMode="contained"
							[disabled]="!canManageGroupPermissions || availableSelectedRowKeys.length === 0"
							(onClick)="assignSelectedPermissions(filteredPermissions(permissionRows, filterState.searchValue ?? ''))">
						</dx-button>
						<dx-button
							icon="chevronprev"
							text="<"
							type="normal"
							stylingMode="outlined"
							[disabled]="!canManageGroupPermissions || assignedSelectedRowKeys.length === 0"
							(onClick)="removeSelectedPermissions(filteredPermissions(permissionRows, filterState.searchValue ?? ''))">
						</dx-button>
					</div>

					<div class="permission-transfer__panel" *ngIf="assignedPermissions(filteredPermissions(permissionRows, filterState.searchValue ?? '')) as assignedPermissions">
						<div class="permission-transfer__title-row">
							<div class="permission-transfer__title">Assigned permissions</div>
							<div class="permission-transfer__count">{{ assignedPermissions.length }}</div>
						</div>

						<dx-data-grid
							class="permission-transfer__grid"
							[dataSource]="assignedPermissions"
							keyExpr="permissionKey"
							[showBorders]="true"
							[hoverStateEnabled]="true"
							[rowAlternationEnabled]="true"
							[width]="'100%'"
							[columnAutoWidth]="false"
							[wordWrapEnabled]="true"
							[selectedRowKeys]="assignedSelectedRowKeys"
							[selection]="{ mode: canManageGroupPermissions ? 'multiple' : 'none' }"
							(onSelectionChanged)="onAssignedSelectionChanged($event)">
							<dxo-selection [mode]="canManageGroupPermissions ? 'multiple' : 'none'" [showCheckBoxesMode]="canManageGroupPermissions ? 'always' : 'none'" selectAllMode="page"></dxo-selection>
							<dxo-sorting mode="multiple"></dxo-sorting>
							<dxo-filter-row [visible]="false"></dxo-filter-row>
							<dxo-search-panel [visible]="false"></dxo-search-panel>
							<dxo-paging [enabled]="true" [pageSize]="12"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
							<dxi-column dataField="category" caption="Group" [width]="160"></dxi-column>
							<dxi-column dataField="displayPermissionName" caption="Permission" [minWidth]="180"></dxi-column>
							<dxi-column dataField="permissionCode" caption="Code" [width]="250"></dxi-column>
							<dxi-column dataField="permissionKey" caption="ID" [visible]="false"></dxi-column>
							<dxi-column dataField="displayPermissionDescription" caption="Permission description" [minWidth]="180"></dxi-column>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>

	<dx-popup
		[(visible)]="permissionReviewVisible"
		[showCloseButton]="true"
		[showTitle]="true"
		[width]="960"
		[height]="'80vh'"
		[dragEnabled]="true"
		[closeOnOutsideClick]="!(saving$ | async)"
		title="Review group permission changes"
		(onHiding)="closePermissionReview()">
		<div class="permission-review">
			<div class="permission-review__intro">
				<div>
					<div class="permission-review__eyebrow">Superadmin review required</div>
					<div class="permission-review__title">{{ formModel.name }} permission impact</div>
				</div>
				<div class="permission-review__summary">
					<div class="permission-review__summary-item permission-review__summary-item--add">
						<span>{{ permissionReviewAddedPermissions.length }}</span>
						Permissions added
					</div>
					<div class="permission-review__summary-item permission-review__summary-item--remove">
						<span>{{ permissionReviewRemovedPermissions.length }}</span>
						Permissions removed
					</div>
					<div class="permission-review__summary-item">
						<span>{{ permissionReviewAffectedUsers.length }}</span>
						Users in group
					</div>
				</div>
			</div>

			<div class="permission-review__warning">
				These changes will affect every user assigned to this group. The server will only accept this save for Super ApplicationLink Administrators.
			</div>

			<div class="permission-review__section" *ngIf="permissionReviewAddedPermissions.length > 0">
				<div class="permission-review__section-title">Permissions that will be added</div>
				<dx-data-grid
					[dataSource]="permissionReviewAddedPermissions"
					[showBorders]="true"
					[rowAlternationEnabled]="true"
					[columnAutoWidth]="false"
					[wordWrapEnabled]="true">
					<dxo-sorting mode="multiple"></dxo-sorting>
					<dxo-paging [enabled]="true" [pageSize]="8"></dxo-paging>
					<dxo-pager [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
					<dxi-column dataField="category" caption="Group" [width]="180"></dxi-column>
					<dxi-column dataField="displayPermissionName" caption="Permission" [minWidth]="180"></dxi-column>
					<dxi-column dataField="permissionCode" caption="Code" [width]="250"></dxi-column>
					<dxi-column dataField="displayPermissionDescription" caption="Permission description" [minWidth]="220"></dxi-column>
				</dx-data-grid>
			</div>

			<div class="permission-review__section" *ngIf="permissionReviewRemovedPermissions.length > 0">
				<div class="permission-review__section-title">Permissions that will be removed</div>
				<dx-data-grid
					[dataSource]="permissionReviewRemovedPermissions"
					[showBorders]="true"
					[rowAlternationEnabled]="true"
					[columnAutoWidth]="false"
					[wordWrapEnabled]="true">
					<dxo-sorting mode="multiple"></dxo-sorting>
					<dxo-paging [enabled]="true" [pageSize]="8"></dxo-paging>
					<dxo-pager [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
					<dxi-column dataField="category" caption="Group" [width]="180"></dxi-column>
					<dxi-column dataField="displayPermissionName" caption="Permission" [minWidth]="180"></dxi-column>
					<dxi-column dataField="permissionCode" caption="Code" [width]="250"></dxi-column>
					<dxi-column dataField="displayPermissionDescription" caption="Permission description" [minWidth]="220"></dxi-column>
				</dx-data-grid>
			</div>

			<div class="permission-review__section" *ngIf="permissionReviewAffectedUsers.length > 0">
				<div class="permission-review__section-title">Users currently assigned to this group</div>
				<dx-data-grid
					[dataSource]="permissionReviewAffectedUsers"
					[showBorders]="true"
					[rowAlternationEnabled]="true">
					<dxo-paging [enabled]="true" [pageSize]="8"></dxo-paging>
					<dxo-pager [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
					<dxi-column dataField="userDisplayName" caption="User"></dxi-column>
					<dxi-column dataField="userId" caption="User ID" [width]="120"></dxi-column>
				</dx-data-grid>
			</div>

			<div class="permission-review__empty" *ngIf="permissionReviewAffectedUsers.length === 0">
				No users are currently assigned to this group.
			</div>

			<div class="permission-review__actions">
				<dx-button text="Cancel" type="normal" [disabled]="saving$ | async" (onClick)="closePermissionReview()"></dx-button>
				<dx-button text="Confirm and save" type="success" icon="save" [disabled]="saving$ | async" (onClick)="confirmPermissionReview()"></dx-button>
			</div>
		</div>
	</dx-popup>
</ng-container>
